import React, { ReactElement } from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

interface SwitchIconProps {
  id?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  onDescription?: string | JSX.Element;
  offDescription?: string | JSX.Element;
  additionalExplanation?: string;
  disabled?: boolean;
  size?: SizeProp;
  labelClassName?: string;
  styleOptions?: FontAwesomeIconProps;
  color?: string;
}

const SwitchIcon = (props: SwitchIconProps): ReactElement => {
  const {
    id,
    value,
    onChange,
    onDescription,
    offDescription,
    additionalExplanation,
    disabled,
    labelClassName,
    styleOptions,
    color = '#1AA08F',
    size = '2x',
  } = props;

  const onClick = (): void => {
    if (!disabled) onChange(!value);
  };

  return (
    <>
      <div
        aria-disabled={disabled}
        className="switch-icon d-flex flex-row"
        onClick={onClick}
      >
        <FontAwesomeIcon
          color={value ? color : '#979797'}
          icon={faToggleOn}
          id={id}
          onClick={onClick}
          rotation={value ? undefined : 180}
          size={size}
          {...styleOptions}
        />
        {value && onDescription && (
          <div className={`switch-description ${labelClassName || ''}`}>
            {onDescription}
          </div>
        )}
        {!value && offDescription && (
          <div className={`switch-description ${labelClassName || ''}`}>
            {offDescription}
          </div>
        )}
      </div>
      {additionalExplanation && (
        <div className={`additional-explanation`}>{additionalExplanation}</div>
      )}
    </>
  );
};

export default SwitchIcon;
